/* eslint-disable @typescript-eslint/ban-ts-comment */
export const widgetChatTheme = (color: string) => {
    return {
        //@ts-ignore
        Button: {
            colors: {
                activeChat: {
                    // Styling of send button when content exists in chat input
                    color: "#fff", // Fill of icon
                    bgColor: `${color}`, // Background fill of button
                    borderColor: "transparent", // Outline of button
                    hoverBgColor: `${color}D9`, // Background fill of button on hover
                    outlineColor: `${color}80`, // Focus color when navigating by keyboard
                },
            },
        },
        chat: {
            message: {
                // Message bubble on the right
                backgroundColor: `${color}`,
                textColor: "#FFF",
                linkColor: "#FFF",
                // Message bubble on the left
                altBackgroundColor: "#FFF",
                altTextColor: "#292929",
                altLinkColor: `${color}`,
            },
        },
    };
};
